import React from 'react'
import usePanelContext from 'refactor/hooks/usePanelContext'
import QuestStream from './QuestStream'
import MusicDiscover from './MusicDiscover'
import MyMusic from './MyMusic'
import RadioArtists from './RadioArtists'
import { useMusicPanelView } from './musicPanelView'
import type { Filter } from 'components/filters/useStreamFilters'

// Music is the Radio team stream with three tabs: every public song (Discover),
// the artists who have aired on it (Artists), and the viewer's own (My Music). The station's latest song
// rides in the Music header; its posts show only as search results. The tabs
// and orders live in the Music header (SearchHeader); this is the body they switch.
export default function MusicStream({
    filter,
    hideSearchHeader,
}: {
    filter: Filter
    hideSearchHeader?: boolean
}) {
    const { panel } = usePanelContext()
    const view = useMusicPanelView(panel?.panelId)
    // Search swaps the header (no tabs there), so it always shows the stream's results.
    const tab = filter?.search ? 'radio' : view.tab

    if (tab === 'discover') return <MusicDiscover panelId={panel?.panelId} />
    if (tab === 'mine') return <MyMusic />
    return tab === 'radio' ? (
        <QuestStream filter={filter} hideSearchHeader={hideSearchHeader} />
    ) : (
        <RadioArtists panelId={panel?.panelId} />
    )
}
